import './InfoSection.css';

function InfoSection({title, subtitle, items, numbered = false}) {
  return (
    <section className='info-section'>
      <div className='title'>
        {title}
      </div>
      {subtitle &&
        <div className='subtitle'>
          {subtitle}
        </div>
      }
      {items.map((item, index) => (
        <div className='type'>
          <img className='small-screen' src={item.img} alt=''/>
          {((index % 2) === 0) && (
            <img className='big-screen' src={item.img} alt=''/>
          )}
          <div className='description-container'>
            {numbered && (
              <div className='index'>{index + 1}.</div>
            )}
            <div>
              <div className='title'>
                {item.title}
              </div>
              <div className='description'>
                {item.description}
              </div>
            </div>
          </div>
          {((index % 2) === 1) && (
            <img className='big-screen' src={item.img} alt=''/>
          )}
        </div>
      ))}
    </section>
  )
}

export default InfoSection;